// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".filter-popover {\n  padding: 16px;\n}\n.el-tabs__nav-scroll {\n  padding: 0 32px;\n}\n.main .el-tabs__nav-scroll {\n  padding: 0;\n}\n.main ::v-deep .el-divider--horizontal {\n  margin-top: 0px;\n}\n.sub-tabs .el-tabs__header {\n  margin: 0 32px 15px;\n}\n.sub-tabs .el-tabs__nav-scroll {\n  padding: 0;\n}\n.el-divider--horizontal {\n  margin-bottom: 0;\n}\n.role-edit-box .red_tabs .el-tabs__content {\n  height: calc(100vh - 188px);\n}", ""]);
// Exports
module.exports = exports;
